// extracted by mini-css-extract-plugin
module.exports = {"cameraLayout":"styles_cameraLayout__wTHv9","webcamWrapper":"styles_webcamWrapper__1Ncw3","webcam":"styles_webcam__1v3w4","errorContainer":"styles_errorContainer__2S6Sn"};